import { useEffect, useState } from 'react';
import { toast } from 'sonner';
import api, { errMsg } from '../lib/api';
import { PageHead } from './components';
import { fmtDate } from '../lib/shop';

export default function AdminCustomers() {
  const [customers, setCustomers] = useState([]);
  const [messages, setMessages] = useState([]);
  const [interest, setInterest] = useState([]);
  const [newsletter, setNewsletter] = useState([]);
  const [tab, setTab] = useState('customers');

  useEffect(() => {
    api.get('/admin/customers').then((r) => setCustomers(r.data)).catch((e) => toast.error(errMsg(e)));
    api.get('/admin/messages').then((r) => setMessages(r.data)).catch(() => {});
    api.get('/admin/interest').then((r) => setInterest(r.data)).catch(() => {});
    api.get('/admin/newsletter').then((r) => setNewsletter(r.data)).catch(() => {});
  }, []);

  const markRead = async (m) => {
    await api.put(`/admin/messages/${m.id}`, { status: 'read' });
    setMessages((ms) => ms.map((x) => (x.id === m.id ? { ...x, status: 'read' } : x)));
  };

  const TABS = [['customers', `Customers (${customers.length})`], ['messages', `Messages (${messages.filter((m) => m.status === 'new').length} new)`], ['interest', `Interest (${interest.length})`], ['newsletter', `Newsletter (${newsletter.length})`]];

  return (
    <div data-testid="admin-customers">
      <PageHead title="Customers" sub="Accounts, contact messages, interest registrations and newsletter signups." />
      <div className="flex gap-1 border-b hairline mb-5 overflow-x-auto">
        {TABS.map(([k, l]) => (
          <button key={k} data-testid={`customers-tab-${k}`} onClick={() => setTab(k)}
            className={`px-3 py-2.5 font-mono2 text-[10px] uppercase tracking-widest whitespace-nowrap border-b-2 -mb-px ${tab === k ? 'border-[#0B0F12]' : 'border-transparent text-[#8A8F95]'}`}>{l}</button>
        ))}
      </div>

      {tab === 'customers' && (
        <div className="border hairline bg-white overflow-x-auto">
          <table className="w-full min-w-[600px] text-sm">
            <thead><tr className="border-b hairline">{['Name', 'Email', 'Verified', 'Orders', 'Joined'].map((h) => <th key={h} className="text-left p-3 font-mono2 text-[10px] uppercase tracking-widest text-[#8A8F95]">{h}</th>)}</tr></thead>
            <tbody>
              {customers.map((c) => (
                <tr key={c.user_id} className="border-b hairline last:border-0">
                  <td className="p-3 font-semibold">{c.name}</td>
                  <td className="p-3 font-mono2 text-xs">{c.email}</td>
                  <td className="p-3">{c.email_verified ? '✓' : '—'}</td>
                  <td className="p-3 font-mono2">{c.order_count}</td>
                  <td className="p-3 text-xs text-[#8A8F95]">{fmtDate(c.created_at)}</td>
                </tr>
              ))}
              {customers.length === 0 && <tr><td colSpan={5} className="p-8 text-center text-[#8A8F95]">No customers yet</td></tr>}
            </tbody>
          </table>
        </div>
      )}

      {tab === 'messages' && (
        <div className="space-y-3">
          {messages.map((m) => (
            <div key={m.id} data-testid={`message-${m.id}`} className={`border hairline bg-white p-5 ${m.status === 'new' ? 'border-l-2 border-l-[#E54D2E]' : 'opacity-70'}`}>
              <div className="flex justify-between flex-wrap gap-2">
                <p className="font-display font-bold uppercase">{m.subject || 'No subject'}</p>
                <p className="font-mono2 text-[10px] text-[#8A8F95]">{m.name} · {m.email} · {fmtDate(m.created_at)}</p>
              </div>
              <p className="text-sm text-[#575B60] mt-2">{m.message}</p>
              {m.status === 'new' && <button data-testid={`message-read-${m.id}`} onClick={() => markRead(m)} className="mt-3 font-mono2 text-[10px] uppercase tracking-widest underline underline-offset-4">Mark read</button>}
            </div>
          ))}
          {messages.length === 0 && <p className="text-sm text-[#8A8F95] border hairline bg-white p-8 text-center">No messages</p>}
        </div>
      )}

      {tab === 'interest' && (
        <div className="border hairline bg-white overflow-x-auto">
          <table className="w-full min-w-[500px] text-sm">
            <thead><tr className="border-b hairline">{['Product', 'Email', 'Registered'].map((h) => <th key={h} className="text-left p-3 font-mono2 text-[10px] uppercase tracking-widest text-[#8A8F95]">{h}</th>)}</tr></thead>
            <tbody>
              {interest.map((i, x) => (
                <tr key={x} className="border-b hairline last:border-0">
                  <td className="p-3 font-semibold">{i.product_name}</td>
                  <td className="p-3 font-mono2 text-xs">{i.email}</td>
                  <td className="p-3 text-xs text-[#8A8F95]">{fmtDate(i.created_at)}</td>
                </tr>
              ))}
              {interest.length === 0 && <tr><td colSpan={3} className="p-8 text-center text-[#8A8F95]">No interest registrations</td></tr>}
            </tbody>
          </table>
        </div>
      )}

      {tab === 'newsletter' && (
        <div className="border hairline bg-white p-5">
          <div className="space-y-1.5 font-mono2 text-xs">
            {newsletter.map((n, i) => <p key={i} className="border-b hairline py-1.5 last:border-0">{n.email}</p>)}
            {newsletter.length === 0 && <p className="text-[#8A8F95]">No subscribers yet</p>}
          </div>
        </div>
      )}
    </div>
  );
}
